import { render, staticRenderFns } from "./msgDetail.vue?vue&type=template&id=d9cb8c7c&scoped=true"
import script from "./msgDetail.vue?vue&type=script&lang=js"
export * from "./msgDetail.vue?vue&type=script&lang=js"
import style0 from "./msgDetail.vue?vue&type=style&index=0&id=d9cb8c7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cb8c7c",
  null
  
)

export default component.exports